import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import GuestUsersListLayer from "../components/GuestUsersListLayer";

const GuestUsersListPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Guest Users" />
      <GuestUsersListLayer />
    </MasterLayout>
  );
};

export default GuestUsersListPage;
